// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpH5, SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  documentRequestDetails: Object,
};

const DeleteSelectedDocument = (props: Props) => {
  const {
    visible,
    close,
    submit,
    documentRequestDetails,
  } = props;

  const deleteSelectedDocument = () => {
    submit();
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={deleteSelectedDocument} type="danger">Delete</SpButton>,
      ]}
      title="Delete Request"
    >
      <div className="px-4">
        <h6 className="mt-1 mb-2">Are you sure you want to delete this request?</h6>
        <SpH5 className="pb-3">
          <div>{documentRequestDetails.name ? documentRequestDetails.name : <>&#8211;</>}</div>
        </SpH5>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default DeleteSelectedDocument;
